import { render, staticRenderFns } from "./DepositGroup.vue?vue&type=template&id=cfa882aa&scoped=true&"
import script from "./DepositGroup.vue?vue&type=script&lang=js&"
export * from "./DepositGroup.vue?vue&type=script&lang=js&"
import style0 from "./DepositGroup.vue?vue&type=style&index=0&id=cfa882aa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cfa882aa",
  null
  
)

export default component.exports